module.exports = __webpack_public_path__ + "img/19.3aca6df3.jpg";